// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .dealer-discount--2-h0y{font-size:inherit;margin-top:20px;text-align:center}.precise-price-app .dealer-discount__content--14Uec{padding-bottom:10px}.precise-price-app .dealer-discount__value--1E-BF{color:var(--primary-color);font-size:20px;text-align:center;line-height:30px;font-weight:700;margin-top:var(--widget-wrapper-value-margin-top,5px)}", ""]);
// Exports
exports.locals = {
	"dealerDiscount": "dealer-discount--2-h0y",
	"dealerDiscountContent": "dealer-discount__content--14Uec",
	"dealerDiscountValue": "dealer-discount__value--1E-BF"
};
module.exports = exports;
